import * as React from 'react'
import { useTranslation } from 'react-i18next'

import GuestbookItem from './guestbookItem'

import { GuestbookMessage } from '../../../store/commonTypes'
import s from './materialPreview.module.sass'

interface Props {
    guestbookItems: GuestbookMessage[]
    guestbookTotal: number
}

const GuestbookList: React.FunctionComponent<Props> = ({ guestbookItems, guestbookTotal }: Props) => {
    const [t] = useTranslation()
    return (
        <div className={s['materialsPreview guestbook']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>{t('Guestbook')}</div>
                    <div className={s['materialsPreview__counter']}>{guestbookTotal}</div>
                </div>
            </div>
            <div className={s['materialsPreview__list']}>
                {guestbookItems.map((guestbookItem: GuestbookMessage) => (
                    <GuestbookItem guestbookItem={guestbookItem} key={guestbookItem.id} />
                ))}
            </div>
        </div>
    )
}

export default GuestbookList
